import { ShippingInfo as OrdersShippingInfo } from '@modules/Orders/ViewOrders/components/display/ShippingInfo';
import { FC } from 'react';
import type { OrderCustomer, OrderLine } from '@modules/Orders/ViewOrders/models/Order';

interface ShippingInfoProps {
  customer?: OrderCustomer;
  orderId?: number;
  lines?: OrderLine[];
  statusId?: number;
  onUpdate?: () => void;
}

export const ShippingInfo: FC<ShippingInfoProps> = (props) => {
  return <OrdersShippingInfo {...props} />;
};
